export enum Language {
  english = 'en',
  spanish = 'es',
  russian = 'ru',
}
